export enum BOOKMARKS {
    /**
     * @value Error while loading bookmarks
     */
    LOAD_ERROR = 'FRONT.BOOKMARKS.LOAD_ERROR',
}
